import { Tag } from "antd";
import { formatDate, formatPercentage, StatusTag } from "../utils/reportUtils";

const EnrollmentTypeTag = (type) => {
  const statusClassMap = {
    User: "status-tag--completed",
    Group: "status-tag--user-started",
  };
  const statusClass = statusClassMap[type] || "status-tag--not-started";
  return <Tag className={`status-tag ${statusClass}`}>{type}</Tag>;
};

export function getBundleReportColumns() {
  return [
    {
      title: "Name",
      dataIndex: "groupName", 
      key: "name",
      render: (_, record) => (
        <>
          <strong>
            {record.type === "GROUP" ? record.groupName : record.fullName}
          </strong>
          {record.type === "GROUP" && (
            <div className="secondary-name">Users: {record.totalLearners}</div>
          )}
        </>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => EnrollmentTypeTag(type),
    },
    {
      title: "Assigned At",
      dataIndex: "assignedAt",
      key: "assignedAt",
      render: formatDate,
    },
    {
      title: "Deadline",
      dataIndex: "deadline",
      key: "deadline",
      render: formatDate,
    },
    {
      title: "Average Progress",
      dataIndex: "avgProgress",
      key: "avgProgress",
      render: formatPercentage,
    },
    {
      title: "Status",
      dataIndex: "groupStatus",
      key: "status",
      render: (_, record) => {
        const status =
          record.type === "GROUP" ? record.groupStatus : record.bundleStatus;
        return StatusTag(status); 
      },
    },

    {
      title: "Adherence",
      dataIndex: "worstAdherence", 
      key: "worstAdherence",
    }
  ];
}
